import React, { useState } from 'react';
import ufoBackground from '../../assets/ufo-background.svg';
import ideaBackground from '../../assets/idea-background.svg';
import tianBackground from '../../assets/Tian-background.svg';
import shejiaoBackground from '../../assets/shejiao.svg';
import logoImage from '../../assets/来协创，创个业.png';
import rectangleBg from '../../assets/Rectangle 4319.svg';
import createTeamBackground from '../../assets/icons/CreateTeamBackground.svg';
import CreateProposalModal from '../modals/CreateProposalModal';
import CreateFriendPostModal from '../modals/CreateFriendPostModal';
import CreateTeamModal from '../modals/CreateTeamModal';
import SocialDrawer from '../social/SocialDrawer';
import { useEmbeddedAuth } from '../../contexts/EmbeddedAuthContext';
import { getCurrentUser } from '../../services/authService';
import { useRightPanel } from '../../contexts/RightPanelContext';

// TODO: 创建团队功能上线时，将此值改为 true
const TEAM_FEATURE_ENABLED = false;

// Header Component
const Header = () => {
  return (
    <header className="flex w-full flex-col items-stretch mb-4">
      <img
        src={logoImage}
        alt="Synnovator Logo"
        className="aspect-[4.74] object-contain w-[180px] max-w-full"
      />
      <div className="relative w-[264px] h-[20px] mt-1.5 px-[7px]">
        <img
          src={rectangleBg}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover rounded"
        />
        <h1 
          className="relative text-[#00000E] text-xs leading-[22px] font-normal z-10"
          style={{
            height: '20px',
            verticalAlign: 'top',
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'flex-start'
          }}
        >
          大家都在Synnovator寻找机会
        </h1>
      </div>
    </header>
  );
};

// Sub-components for individual cards
const FindTeammatesCard = ({ onClick }) => (
  <article 
    onClick={onClick}
    className="flex-1 rounded-xl px-[18px] py-[11px] cursor-pointer hover:scale-105 transition-transform flex flex-col justify-center overflow-visible relative" 
    style={{ width: '150px', height: '72px' }}
    role="button"
  >
    <img
      src={ufoBackground}
      alt="UFO background"
      className="absolute object-contain rounded-xl"
      style={{ width: '150px', height: '89px', boxSizing: 'content-box', top: '-16px', left: '0px' }}
    />
    <div className="relative flex items-center justify-between z-10">
      <div className="flex flex-col items-start" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
        <div className="text-[#00000E] text-base leading-none font-medium" style={{ fontWeight: 700, fontFamily: 'OPPOSans', height: '23px' }}>找队友</div>
        <div className="text-[#00000E] text-xs leading-[22px] font-normal text-right" style={{ width: '96px', height: '23px' }}>
          找呀找呀找朋友～
        </div>
      </div>
    </div>
  </article>
);

const FindIdeasCard = ({ onClick }) => (
  <article 
    onClick={onClick}
    className="flex-1 rounded-xl px-[18px] py-[11px] cursor-pointer hover:scale-105 transition-transform flex flex-col justify-center overflow-visible relative" 
    style={{ width: '150px', height: '72px' }}
    role="button"
  >
    <img
      src={ideaBackground}
      alt="Idea background"
      className="absolute object-contain rounded-xl"
      style={{ width: '150px', height: '89px', boxSizing: 'content-box', top: '-15px', left: '0px' }}
    />
    <div className="relative flex items-center justify-between z-10">
      <div className="flex flex-col items-start" style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
        <div className="text-[#00000E] text-base leading-none font-medium" style={{ fontWeight: 900, fontFamily: 'OPPOSans', height: '23px' }}>找点子</div>
        <div className="text-[#00000E] text-xs leading-[22px] font-normal text-right" style={{ width: '72px' }}>
          找个好点子～
        </div>
      </div>
    </div>
  </article>
);

const PublishProposalCard = ({ onClick }) => (
  <article 
    onClick={onClick}
    className="rounded-xl px-[18px] py-[13px] cursor-pointer hover:scale-105 transition-transform flex flex-col justify-center overflow-visible relative h-[72px]"
    role="button"
  >
    <img
      src={tianBackground}
      alt="Tian background"
      className="absolute object-contain rounded-xl"
      style={{ width: '326px', height: '72px', boxSizing: 'content-box', top: '0px', left: '0px' }}
    />
    <div className="relative z-10">
      <div className="text-[#00000E] text-sm leading-loose font-medium text-left" style={{ fontWeight: 700, fontFamily: 'OPPOSans' }}>
        发布提案
      </div>
      <div className="text-[#00000E] text-xs leading-[22px] font-normal text-left">
        发布一个小提案啦啦啦啦啦～
      </div>
    </div>
  </article>
);

const SocialMediaCard = ({ onClick }) => (
  <article 
    onClick={onClick}
    className="w-[188px] h-[72px] rounded-xl px-[18px] py-[11px] cursor-pointer hover:scale-105 transition-transform flex flex-col justify-center overflow-visible relative"
    role="button"
  >
    <img
      src={shejiaoBackground}
      alt="Social media background"
      className="absolute object-contain rounded-xl"
      style={{ width: '188px', height: '72px', boxSizing: 'content-box', top: '0px', left: '0px' }}
    />
    <div className="relative z-10 flex items-center justify-between">
      <div className="flex flex-col items-start justify-start flex-1">
        <div className="text-[#00000E] text-sm leading-loose font-medium h-[23px]" style={{ fontWeight: 700, fontFamily: 'OPPOSans' }}>社交媒体</div>
        <div className="text-[#00000E] text-xs leading-[22px] font-normal text-right w-[156px]">
          发布一个小媒体啦啦啦啦啦～
        </div>
      </div>
    </div>
  </article>
);

const TeamMediaCard = () => (
  <article className="flex-1 bg-[#DCDCDC] rounded-xl px-[17px] py-[13px] cursor-not-allowed flex flex-col justify-center h-[72px] w-[112px]">
    <div className="text-[#666] text-sm leading-loose font-medium text-left h-[23px]" style={{ fontWeight: 700, fontFamily: 'OPPOSans' }}>
      团队媒体
    </div>
    <div className="text-[#666] text-xs leading-[22px] font-normal text-left">
      敬请期待
    </div>
  </article>
);

const CreateTeamCard = ({ enabled, onClick }) => {
  const [isButtonHovered, setIsButtonHovered] = React.useState(false);

  if (!enabled) {
    return (
      <article className="w-full bg-[#DCDCDC] rounded-xl px-[18px] py-[13px] cursor-not-allowed flex flex-col justify-center h-[72px]">
        <div className="text-[#666] text-sm leading-loose font-medium text-left h-[23px]" style={{ fontWeight: 700, fontFamily: 'OPPOSans' }}>
          创建团队
        </div>
        <div className="text-[#666] text-xs leading-[22px] font-normal text-left">
          敬请期待
        </div>
      </article>
    );
  }

  return (
    <article className="flex flex-col overflow-visible relative aspect-[4.306] w-full items-stretch pl-[18px] pr-[18px] py-[9px] justify-center group h-[72px]">
      <img
        src={createTeamBackground}
        alt="Create Team Background"
        onClick={onClick}
        className={`absolute inset-0 h-full w-full rounded-xl cursor-pointer transition-transform origin-center ${!isButtonHovered ? 'group-hover:scale-[1.02]' : ''}`}
        style={{ pointerEvents: 'auto', height: '72px' }}
        role="button"
      />
      <div className="relative flex w-full h-[72px] gap-[88px] justify-between items-start pointer-events-none pr-[25px]">
        <div className={`flex flex-col items-start justify-center h-[72px] pointer-events-none transition-transform origin-center ${!isButtonHovered ? 'group-hover:scale-[1.02]' : ''}`}>
          <div className="text-[#00000E] text-sm leading-loose font-medium h-[23px]" style={{ display: 'flex', flexWrap: 'wrap', fontWeight: 900, fontFamily: 'OPPOSans' }}>
            创建团队
          </div>
          <p className="text-[#00000E] text-xs leading-[22px] font-normal text-left h-[23px] w-[132px]">
            我要找志同道合的朋友们
          </p>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick?.();
          }}
          onMouseEnter={() => setIsButtonHovered(true)}
          onMouseLeave={() => setIsButtonHovered(false)}
          className="absolute right-[-19px] top-[1px] justify-center items-center bg-[#00000E] flex h-[24px] gap-1.5 text-xs text-white px-3 rounded-[15.75px] hover:bg-gray-800 hover:scale-105 transition-all cursor-pointer pointer-events-auto z-10"
        >
          <span className="font-semibold inline-block w-[48px]">加入队伍</span>
        </button>
      </div>
    </article>
  );
};

const PublishCard = () => {
  const { showLoginModal } = useEmbeddedAuth();
  const { togglePanel, closePanel, mode } = useRightPanel();
  const [proposalModalVisible, setProposalModalVisible] = useState(false);
  const [postModalVisible, setPostModalVisible] = useState(false);
  const [teamModalVisible, setTeamModalVisible] = useState(false);
  const [socialDrawerVisible, setSocialDrawerVisible] = useState(false);
  const [postType, setPostType] = useState('post'); // 'post' for social/teammates, 'idea' for ideas

  const checkAuth = () => {
    const user = getCurrentUser();
    if (!user) {
      showLoginModal();
      return false;
    }
    return true;
  };

  const handleCreateProposal = () => {
    if (checkAuth()) {
      setProposalModalVisible(true);
    }
  };

  const handleCreatePost = (type = 'social') => {
    if (checkAuth()) {
      setPostType(type);
      setPostModalVisible(true);
    }
  };

  const handleCreateSocial = () => {
    if (checkAuth()) {
      setSocialDrawerVisible(true);
    }
  };

  const handleCreateTeam = () => {
    if (!TEAM_FEATURE_ENABLED) return;
    if (checkAuth()) {
      setTeamModalVisible(true);
    }
  };

  const handleClose = () => {
    if (mode === 'drawer') {
      closePanel();
      return;
    }
    togglePanel('hot');
  };

  return (
    <div 
      className="p-4 flex flex-col h-full rounded-[20px] overflow-hidden relative"
      style={{
        background: 'linear-gradient(359deg, #FFF 12.31%, #F7FEFF 79.66%, #47FFB2 112.32%)'
      }}
    >
      <Header />
      
      {/* Spacer to push content down */}
      <div className="flex-grow"></div>

      {/* Button Group Container */}
      <div className="flex flex-col gap-[12px] mb-[120px] relative">
        {/* Main action cards */}
        <section className="flex w-full items-stretch gap-2">
          <FindTeammatesCard onClick={() => handleCreatePost('friend')} />
          <FindIdeasCard onClick={() => handleCreatePost('idea')} />
        </section>

        {/* Publish proposal */}
        <PublishProposalCard onClick={handleCreateProposal} />

        {/* Media cards */}
        <section className="flex items-stretch gap-2">
          <SocialMediaCard onClick={handleCreateSocial} />
          <TeamMediaCard />
        </section>

        {/* Create team */}
        <CreateTeamCard enabled={TEAM_FEATURE_ENABLED} onClick={handleCreateTeam} />
        
        {/* Close Button positioned relative to the button group */}
        <div className="absolute left-0 right-0 flex justify-center" style={{ top: '100%', marginTop: '20px' }}>
          <button 
            aria-label="关闭多功能区"
            onClick={handleClose}
            className="w-[92px] h-[92px] rounded-full flex items-center justify-center cursor-pointer hover:bg-white/90 transition-colors"
            style={{
              background: '#F8F8F8',
              padding: '34px',
              gap: '10px'
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="#00000E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 6L18 18" stroke="#00000E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>

      {/* Modals */}
      <CreateProposalModal 
        visible={proposalModalVisible} 
        onCancel={() => setProposalModalVisible(false)}
        onSuccess={() => {
          setProposalModalVisible(false);
        }}
      />
      
      <CreateFriendPostModal 
        visible={postModalVisible} 
        onCancel={() => setPostModalVisible(false)}
        type={postType}
        defaultTopics={postType === 'friend' ? ['找队友'] : []}
        lockTopics={postType === 'friend' ? ['找队友'] : []}
        excludeTopics={postType === 'idea' ? ['找队友'] : []}
        onSuccess={() => {
          setPostModalVisible(false);
        }}
      />

      <SocialDrawer
        visible={socialDrawerVisible}
        onClose={() => setSocialDrawerVisible(false)}
        onSuccess={() => {
          // 这里可以添加成功后的回调，比如提示用户
          setSocialDrawerVisible(false);
        }}
      />

      {TEAM_FEATURE_ENABLED ? (
        <CreateTeamModal
          open={teamModalVisible}
          onCancel={() => setTeamModalVisible(false)}
          onSuccess={() => {
            setTeamModalVisible(false);
          }}
        />
      ) : null}
    </div>
  );
};

export default PublishCard;
